/**
 * Weather Sensor Configuration
 *
 * Defines labels and visibility settings for all weather sensors in the dashboard.
 *
 * Structure:
 * Each sensor has:
 * - label: Display name for the sensor
 * - visible: Boolean indicating whether to show the sensor
 *
 * Available Sensors:
 * - temperature_ext: External temperature
 * - temperature_int: Internal temperature
 * - humidity_ext: External humidity
 * - humidity_int: Internal humidity
 * - surface_air_pressure: Air pressure
 * - wind_speed: Current wind speed
 * - wind_direction: Wind direction
 * - wind_gust_speed: Maximum gust speed
 * - wind_gust_direction: Gust direction
 * - wind_compass: Combined wind display
 * - snow_depth: Snow depth measurement
 * - voltage: Battery voltage
 * - surface_downwelling_shortwave_flux: Solar radiation
 * - pitch: Station pitch angle
 * - roll: Station roll angle
 * - wind_chill: Calculated wind chill
 * - air_dewpoint: Dew point temperature
 * - heat_index: Heat index value
 *
 * Usage:
 * - Controls which sensors are displayed in the dashboard
 * - Provides consistent labeling across the application
 * - Used by WeatherDashboard and WarningBanner components
 * - Supports internationalization through translation
 */

export const SENSOR_LABELS = {
  temperature_ext: { label: "Temperature", visible: true },
  temperature_int: { label: "Internal Temperature", visible: false },
  humidity_ext: { label: "Humidity", visible: true },
  humidity_int: { label: "Internal Humidity", visible: false },
  surface_air_pressure: { label: "Pressure", visible: false },
  wind_speed: { label: "Wind Speed", visible: true },
  wind_direction: { label: "Wind Direction", visible: true },
  wind_gust_speed: { label: "Wind Gust Speed", visible: true },
  wind_gust_direction: { label: "Wind Gust Direction", visible: false },
  wind_compass: { label: "Wind", visible: true },
  snow_depth: { label: "Snow Depth", visible: true },
  voltage: { label: "Battery", visible: false },
  surface_downwelling_shortwave_flux: { label: "Solar", visible: false },
  pitch: { label: "Pitch", visible: false },
  roll: { label: "Roll", visible: false },
  wind_chill: { label: "Wind Chill", visible: true },
  // NTI specific sensors
  air_dewpoint: { label: "Dew Point", visible: true },
  heat_index: { label: "Heat Index", visible: true },
};
